module.exports = __webpack_public_path__ + "static/media/thunderbolt_rig_constructing.1f523038.mp4";